import {first} from "lodash";

require('angular');

const RESET_AFTER = 1000;

const AtmtGroupStarController = ['$timeout', '$scope', 'GM_STAR_STATES', 'GM_STAR_CSS_NAMES', function ($timeout, $scope, GM_STAR_STATES, GM_STAR_CSS_NAMES) {
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.GM_STAR_STATES = GM_STAR_STATES;
    this.GM_STAR_CSS_NAMES = GM_STAR_CSS_NAMES;

    this._init = () => {
        this._innerState = this.GM_STAR_STATES[0];
    };

    this._initWatch = () => {
        this.$scope.$watch('ctrl._innerState', (state) => {
            this._watchChangeState(state.toString());
        });
    };

    this.click = () => {
        this.nextState();
    };

    this._watchChangeState = (state) => {
        const idx = this.GM_STAR_STATES.indexOf(state);
        const firstTimeCheck = _.isUndefined(this._stateIdx);

        if (idx > -1) {
            this._cancelSaveTimeout();
            if (!firstTimeCheck) {
                this._scheduleSave();
            }
            this._stateIdx = idx;
            if (firstTimeCheck && this._stateIdx > 0) {
                this._nextStateIdx = 0;
            } else {
                this._nextStateIdx = (this._stateIdx + 1) % this.GM_STAR_STATES.length;
            }
            this._stateCss = this.GM_STAR_CSS_NAMES[state];
        } else {
            this._nextStateIdx = 1;
        }
    };

    this._cancelSaveTimeout = () => {
        this.$timeout.cancel(this._saveTimeout);
    };

    this._scheduleSave = () => {
        this._saveTimeout = this.$timeout(this.save.bind(this), RESET_AFTER);
    };

    this.save = () => {
        if (_.isFunction(this.onSave)) {
            this.onSave({ params: {} });
        }
        this._innerState = this.GM_STAR_STATES[0];
        this._nextStateIdx = 1;
    };

    this.nextState = () => {
        this._stateIdx = this._nextStateIdx;
        this._innerState = this.GM_STAR_STATES[this._stateIdx];

        let groupIdFound = false;
        let updating = false;
        for (let i = 0; i < this.checklist.items.length; i++) {
            let item = this.checklist.items[i];
            if (item._id === this.groupId && item.isSeparator) {
                groupIdFound = true;
                updating = true;
                continue;
            }
            if (groupIdFound && item.isSeparator && item._id !== this.groupId) {
                updating = false;
                break;
            }
            if (updating) {
                item.value = parseInt(this._innerState);
            }
        }
    };

    this._init();
    this._initWatch();
}];

const atmtGroupStarDirective = () => {
    return {
        restrict: 'EA',
        scope: {},
        controller: 'AtmtGroupStarController',
        controllerAs: 'ctrl',
        bindToController: {
            'checklist': '=',
            'groupId': '=',
            'onSave': '&?'
        },
        template:'<div class="atmt__star atmt__group_star" ng-class="ctrl._stateCss" ng-click="ctrl.click($event)"></div>',
        link: function(scope, element, attrs, ctrl) {
            const doneEmojis = ['✅', '😏', '👌🏼', '🙆🏼', '🆗', '🦸🏼‍♀️', '🫂', '😁', '🙌🏼', '😸', '👍🏼', '🦄', '😎', '🤩', '😛', '🤠', '🐵', '🐰', '🐹', '🐭', '🐻‍❄️', '🦈', '🦭', '🦑', '🦚', '👷🏼', '🤹🏼', '🏄🏼', '🏋🏼‍♀️', '💪🏼', '🎉', '✨', '🎊', '🎈', '🎢', '💎', '🎯', '🎸', '🥯', '🍩', '🍉', '🌈', '🏗️', '🥷🏼'];
            const notDoneEmojis = ['😖', '😕', '😱', '🤬', '😶‍🌫️', '😫', '😯', '😲', '☹️', '😞', '🥸', '🫣', '🫨', '💩', '🧟', '👎🏼', '🥉', '🚩'];
            const naEmojis = ['🤷🏼', '💅🏼', '😐', '🫥', '🥱', '🤡', '🤖', '🐷', '⚙️', '🔦', '🍪', '🌏', '💈', '❄️'];

            function getRandomEmoji(type) {
                let emojis;
                if (type === 'done') {
                    emojis = doneEmojis;
                } else if (type === 'not-done') {
                    emojis = notDoneEmojis;
                } else if (type === 'na') {
                    emojis = naEmojis;
                } else {
                    return '';
                }
                return emojis[Math.floor(Math.random() * emojis.length)];
            }

            function showEmojiAnimation(state) {
                let rand = Math.random()
                if (rand < 0.5) {
                    let emojiType;
                    if (state === '1' || state === 'state-1') {
                        emojiType = 'done';
                    } else if (state === '2' || state === 'state-2') {
                        emojiType = 'not-done';
                    } else if (state === '3' || state === 'state-3') {
                        emojiType = 'na';
                    }

                    if (emojiType) {
                        const emoji = getRandomEmoji(emojiType);
                        const spanWrapper = angular.element('<span></span>').text(emoji);
                        twemoji.parse(spanWrapper[0]);
                        const emojiImg = spanWrapper.find('img');
                        element.append(emojiImg);

                        const starRect = element[0].getBoundingClientRect();
                        const emojiFontSize = 32;

                        const centerX = starRect.left + (40 / 2);
                        const centerY = starRect.top + (40 / 2);

                        const startX = centerX - (emojiFontSize / 2);
                        const startY = centerY - (emojiFontSize / 2) - 20;

                        const randomXOffset = (Math.random() * 80) - 40;

                        emojiImg.css({
                            'position': 'fixed',
                            'left': `${startX}px`,
                            'top': `${startY}px`,
                            'opacity': '1',
                            'font-size': `${emojiFontSize}px`,
                            'pointer-events': 'none',
                            'z-index': '9999',
                            'transition': 'all 0.95s ease-out',
                            'width': '32px',
                            'height': '32px',
                        });

                        setTimeout(() => {
                            emojiImg.css({
                                'top': `${startY - 120}px`,
                                'left': `${startX + randomXOffset}px`,
                                'opacity': '0',
                            });
                        }, 20);

                        emojiImg.on('transitionend', () => {
                            emojiImg.remove();
                        });
                    }
                }
            }

            let lastAnimationTime = 0;
            const originalSave = ctrl.save;
            ctrl.save = function () {
                const currentState = this._innerState;
                const result = originalSave.apply(this);
                const now = Date.now();
                if (now - lastAnimationTime > 500) {
                    lastAnimationTime = now;
                    showEmojiAnimation(currentState);
                }
                return result;
            }
        }
    }
};

export default angular.module('atmt.groupstar', [])
    .controller('AtmtGroupStarController', AtmtGroupStarController)
    .directive('atmtGroupStar', atmtGroupStarDirective)
    .constant('GM_STAR_STATES', [
        'state-0',
        'state-1',
        'state-2',
        'state-3',
        'state-4'
    ])
    .constant('GM_STAR_CSS_NAMES', {
        'state-0': '',
        'state-1': 'atmt__star-state-1',
        'state-2': 'atmt__star-state-2',
        'state-3': 'atmt__star-state-3',
        'state-4': 'atmt__star-state-4',
        'state-5': 'atmt__star-state-5'
    });